import EditProfile from '../editprofile/EditProfile';
export default EditProfile
